import React, { useState } from 'react';
import './Pricing.css';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa'; // Icon import
import logo from '../../assets/images/logo1.png'; 

const Pricing = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [result, setResult] = useState(""); // Web3Forms status message

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    setResult("");
  };

  // Web3Forms Submission Logic
  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    // Using your Access Key
    formData.append("access_key", "68f8c92b-95f6-4539-bca9-456711228405");
    formData.append("subject", "Price Unlock Request - Pricing Section");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Price Details Sent Successfully!");
      event.target.reset();
      setTimeout(() => {
        closeModal();
      }, 2500);
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  const plans = [
    { 
      type: "2 BHK", 
      area: "825", 
      img: "https://tse4.mm.bing.net/th/id/OIP.-cnlx-LUIdfu8gE1t6AXwAHaEw?pid=Api&P=0&h=180" 
    },
    { 
      type: "2.5 BHK", 
      area: "998", 
      img: "https://www.propzilla.in/uploads/propertyfloorplans/image/smart-world-one-dxp-2.5bhk-floor-plan.webp" 
    },
    { 
      type: "3 BHK", 
      area: "1028", 
      img: "https://tse3.mm.bing.net/th/id/OIP.M0cG_HYluGm4-jK-8QnJnAHaDt?pid=Api&P=0&h=180" 
    }
  ];

  const cardVariants = {
    hidden: { opacity: 0, x: -80 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.2,
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }
    })
  };

  return (
    <section id="pricing" className="pricing-section">
      <div className="pricing-container">
        
        <motion.div 
          className="pricing-header"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{ duration: 0.8 }}
        >
          <div className="pricing-line"></div>
          <h2 className="pricing-main-title">Pricing & Floor Plan</h2>
          <div className="pricing-line"></div>
        </motion.div>

        <motion.p 
          className="pricing-desc"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: false }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          Sentosa Era Moshi offers spacious 2, 2.5 & 3 BHK floor plans designed for luxury and comfort.
        </motion.p>

        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <motion.div 
              key={index} 
              className="pricing-card"
              custom={index}
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.2 }}
            >
              <div className="floor-plan-img-container">
                <img src={plan.img} alt={plan.type} className="floor-plan-img" />
              </div>

              <div className="plan-info">
                <h3 className="plan-type">{plan.type}</h3>
                <p className="carpet-label">Carpet Area</p>
                <h4 className="area-value">{plan.area} <span>Sq.Ft.</span></h4>
              </div>

              <button className="unlock-btn" onClick={openModal}>Unlock Price</button>
            </motion.div>
          ))}
        </div>
      </div>

      {/* --- UPDATED FORM MODAL --- */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            
            <div className="modal-content">
              <div className="modal-logo">
                <img src={logo} alt="Logo" />
              </div>
              <h2 className="enquire-title">Enquire Now</h2>
              
              <form className="modal-form" onSubmit={onSubmit}>
                <input type="text" name="first_name" placeholder="First Name" required />
                <input type="text" name="last_name" placeholder="Last Name" required />
                <input type="email" name="email" placeholder="Email Id" required />
                <input type="tel" name="mobile" placeholder="Mobile No." required />
                
                {/* <select name="project" required className="modal-select">
                  <option value="" disabled selected>Select Project</option>
                  <option value="Sentosa Era">Sentosa Era</option>
                </select> */}

                <div className="checkbox-container">
                  <input type="checkbox" id="pricing-consent" name="consent" required />
                  <label htmlFor="pricing-consent">
                    I hereby authorize to send notification on SMS, Calls, RCS, WhatsApp.
                  </label>
                </div>

                <button type="submit" className="modal-submit-btn">
                  SUBMIT NOW <FaArrowRight style={{marginLeft: '8px'}} />
                </button>
              </form>

              {result && <p className="form-status">{result}</p>}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Pricing;